import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { extraSurveyPartPermission, hasPermission } from 'unihow-common';

import SelectSurveyPartTypeDialog from '../SelectSurveyPartTypeDialog';
import { routes } from '../../../constants';

import styles from '../SurveySchemas.module.css';
import useTitle from '../../../hooks/useTitle';
import BrowseSurveyParts from '../BrowseSurveyParts';

const ExtraSurveyParts = ({ translate: t }) => {
  const perms = useSelector((state) => state.user.currentUser.permissions);

  const isExtraSurveyPartAdmin = hasPermission(perms, extraSurveyPartPermission(true));
  useTitle(`${t('surveySchemas.title')} - ${t('extraSurveyParts.title')}`);

  return (
    <section>
      <h2 className="panel__title">{t('extraSurveyParts.title')}</h2>
      <p>{t('extraSurveyParts.extraPartsIntroduction')}</p>
      {isExtraSurveyPartAdmin && (
      <div className={styles.actions}>
        <SelectSurveyPartTypeDialog
          confirmRoute={routes.surveySchemas.extraSurveyParts.create.index}
          dataCy="create-extra-question-button"
          buttonText={t('extraSurveyParts.createNew')}
          labelText={t('selectSurveyPartTypeDialog.extraPartLabel')}
        />
      </div>
      )}
      <BrowseSurveyParts isExtraPartsView />
    </section>
  );
};

const { func } = PropTypes;
ExtraSurveyParts.propTypes = {
  translate: func.isRequired
};

export default ExtraSurveyParts;
